export default (Vue) => {
    /**
     * append to body , fixed定位的dom放在不滚动的容器中比较好, 可以使用这个指令移动到body中
     * eg: v-appendToBody="{enable: true, cls: 'xxxx', placeHolder: true}"
     * enable 表示是否启用appendToBody
     * cls 表示启用时追加到当前dom的class
     * placeHolder 表示启用时,是否需要在当前dom的位置上创建一个div用于站位
     */
    Vue.directive('appendToBody', {
        bind(el, binding, vnode) {
            if (!binding.value || binding.value.enable) {
                vnode.context.$nextTick(() => {
                    if (binding.value) {
                        // 补一个占位的div
                        if (binding.value.placeHolder) {
                            var holder = document.createElement('div');
                            holder.style.height = `${el.clientHeight}px`;
                            el.after(holder);
                            el.holder = holder;
                        }
                        // 添加class
                        if (binding.value.cls) {
                            binding.value.cls
                                .split(' ')
                                .forEach((c) => el.classList.add(c));
                        }
                    }
                    window && window.document.body.appendChild(el);
                });
            }
        },
        unbind(el, binding) {
            if (!binding.value || binding.value.enable) {
                if (el.holder) {
                    el.holder.parentNode.removeChild(el.holder);
                }
                window && window.document.body.removeChild(el);
            }
        }
    });
};
